angular
  .module("pe4h")
  .controller("Profile", function (
    $scope,
    $rootScope,
    $http,
    $q,
    configuration,
    Upload,
    $uibModal,
    AuthService,
    $state,
    $stateParams,
    NgMap
  ) {
    $scope.getUserProjects = function () {
      $http({
        url: configuration.webApi.projects.projects,
        method: "GET",
        data: {}
      })
        .success(function (res, status, headers, config) {
          // Add only opened projects
          $scope.userProjects = res.filter(function (item) {
            return item.Status == "open";
          });
        })
        .error(function (error, status, headers, config) {
          console.log("project error: ", error);
        });
    };

    function init() {
      $scope.userProjects = [];
      // If the logged in user is a client, list all his/her projects
      if ($scope.user && $scope.user.IsClient) {
        $scope.getUserProjects();
      }
      $scope.requestProposalData = {};
      $scope.showMainTab = true;
      $scope.profileTypes = [
        "myProfile",
        "clientProposal",
        "clientPublic",
        "professional"
      ];
      $scope.profileData = [];
      $scope.latLng = undefined;
      $scope.minDate = moment()
        .add(1, "month")
        .hours(0)
        .minutes(0)
        .seconds(0);
      $scope.minDateDisplay = $scope.minDate.format("MMMM Do YYYY");

      $scope.datepicker = [];
      $scope.datepicker.options = {
        showWeeks: false,
        minDate: $scope.minDate.toDate()
      };
      switch ($state.$current.name) {
        case "profile":
          $scope.profileType = $scope.profileTypes[0];
          $scope.setProfileInfo($scope.user);
          if ($scope.user.IsProfessional) {
            $scope.getLatLngProfile();
            if ($scope.user.TravelDistanceMeters)
              $scope.profileData.user.travelDistance = $scope.getTravelDistanceMiles(
                $scope.user.TravelDistanceMeters
              ).value; //parseInt( $scope.user.TravelDistanceMeters/ 1609.34);
            else $scope.profileData.user.travelDistance = $scope.noTravelLimits;
          }
          break;
        case "edit-profile":
          $scope.setProfileInfo($scope.user);
          $scope.firstName = $scope.user.FirstName;
          $scope.lastName = $scope.user.LastName;
          $scope.mail = $scope.user.Email;
          $scope.zip = $scope.user.Zip;
          $scope.bio = $scope.user.Bio;
          $scope.file = $scope.user.BioAttachment;
          $scope.website = $scope.user.WebSite;

          NgMap.getMap().then(function (map) {
            console.log(map.getCenter());
            console.log("markers", map.markers);
            console.log("shapes", map.shapes);
          });
          $scope.getLatLng();
          break;
        case "profileProposal":
          var proposalId = parseInt($stateParams.proposalId);
          if (isNaN(proposalId)) {
            $scope.alertError("Error", "Invalid proposal");
            $scope.redirectHome();
          }
          if ($scope.user.IsProfessional) {
            $scope.profileType = $scope.profileTypes[1];
            $scope.getProposalClientInfo(proposalId);
          } else {
            $scope.profileType = $scope.profileTypes[3];
            $scope.getProposalProfessionalInfo(proposalId);
          }
          break;
        case "view-engineer":
          var engineerId = parseInt($stateParams.uid);
          if (isNaN(engineerId)) {
            $scope.alertError("Error", "Invalid engineer Id");
            $scope.redirectHome();
          }
          $scope.profileType = $scope.profileTypes[3];
          $scope.getEngineerInfo(engineerId);
          break;

        /*
      case "profileProject":
        var projectId = parseInt($stateParams.projectId);
        if (isNaN(projectId)) {
          $scope.alertError("Error", "Invalid project");
          $scope.redirectHome();
        }
        $scope.profileType = $scope.profileTypes[2];
        $scope.getPublicProjectClientInfo(projectId);
        break;
      */
      }
    }

    $scope.setProfileInfo = function (user) {
      //console.log(user);
      $scope.profileData.user = user;
      $scope.bio = user.Bio;
      $scope.file = user.BioAttachment;
      $scope.profileData.bio = user.Bio;
      $scope.state = $scope.getStateFromCode(user.State);
      $scope.travelDistance = $scope.getTravelDistanceMiles(
        user.TravelDistanceMeters
      );
      $scope.editUrl();
      $scope.loadProjectHistory();
      $scope.loadLicenses();
      $scope.loadReview();
      if (user.IsProfessional && !$scope.latLng) {
        $scope.getLatLngProfile();
      }
    };

    $scope.getEngineerInfo = function (id) {
      $http({
        url: configuration.webApi.users.engineer({
          id: id
        }),
        method: "GET"
      })
        .success(function (res, status, headers, config) {
          $scope.setProfileInfo(res);
        })
        .error(function (error, status, headers, config) {
          $scope.alertErrorFromServer(error);
        });
    };

    /*
  $scope.getPublicProjectClientInfo = function(projectId) {
    $http({
      url: configuration.webApi.projects.client({
        id: projectId
      }),
      method: "GET"
    }).success(function(res, status, headers, config) {
      $scope.setProfileInfo(res);
    }).error(function(error, status, headers, config) {
      $scope.alertErrorFromServer(error);
      $scope.redirectHome();
    });
  };
  */

    $scope.getProposalClientInfo = function (proposalId) {
      $http({
        url: configuration.webApi.proposals.proposals_id_client({
          id: proposalId
        }),
        method: "GET"
      })
        .success(function (res, status, headers, config) {
          $scope.setProfileInfo(res);
        })
        .error(function (error, status, headers, config) {
          $scope.alertErrorFromServer(error);
          $scope.redirectHome();
        });
    };

    $scope.getProposalProfessionalInfo = function (proposalId) {
      $http({
        url: configuration.webApi.proposals.proposals_id_professional({
          id: proposalId
        }),
        method: "GET"
      })
        .success(function (res, status, headers, config) {
          $scope.setProfileInfo(res);
          $scope.getLatLngProfile();
          if ($scope.user.TravelDistanceMeters)
            $scope.profileData.user.travelDistance = $scope.getTravelDistanceMiles(
              $scope.profileData.user.TravelDistanceMeters
            ).value; //parseInt( $scope.profileData.user.TravelDistanceMeters/ 1609.34);
          else $scope.profileData.user.travelDistance = $scope.noTravelLimits;
        })
        .error(function (error, status, headers, config) {
          $scope.alertErrorFromServer(error);
          $scope.redirectHome();
        });
    };

    $scope.professionalLicenses = [
      {
        type: undefined,
        state: undefined,
        expires: undefined,
        popup: {
          opened: false
        }
      }
    ];

    $scope.feedbackList = [];
    $scope.feedbackRequest = [];
    $scope.feedbackMax = 0;

    $scope.projectHistoryRequest = [];
    $scope.projectHistoryRequestLoaded = false;
    $scope.projectHistoryMax = 0;
    $scope.projectHistoryList = [];

    $scope.professionalLicenses = [];
    $scope.open = function (index) {
      $scope.professionalLicenses[index].popup.opened = true;
    };

    $scope.loadProjectHistoryList = function () {
      var i = 0;
      while (
        i < 7 &&
        $scope.projectHistoryRequest.length > i + $scope.projectHistoryMax
      ) {
        $scope.projectHistoryList.push(
          $scope.projectHistoryRequest[$scope.projectHistoryMax + i]
        );
        i++;
      }
      $scope.projectHistoryMax += i;
      if (i != 7 && $scope.projectHistoryRequest.length != 0) {
        $http({
          url: configuration.webApi.users.projecthistory({
            id: $scope.profileData.user.Id
          }),
          method: "GET",
          data: {
            dateLT:
              $scope.projectHistoryRequest[
                $scope.projectHistoryRequest.length - 1
              ].CreatedDate
          }
        })
          .success(function (res, status, headers, config) {
            $scope.projectHistoryRequest.concat(res);
            while (
              i < 7 &&
              $scope.projectHistoryRequest.length > i + $scope.projectHistoryMax
            ) {
              $scope.projectHistoryList.push(
                $scope.projectHistoryRequest[$scope.projectHistoryMax + i]
              );
              i++;
            }
            $scope.projectHistoryMax += i;
            //console.log($scope.projectHistoryList);
          })
          .error(function (error, status, headers, config) {
            $scope.alertErrorFromServer(error);
            //authFactory.logout();
          });
      }
    };

    $scope.loadFeedbackList = function () {
      if ($scope.profileData.user.IsProfessional) {
        var i = 0;
        while (
          i < 7 &&
          $scope.feedbackRequest.length > i + $scope.feedbackMax
        ) {
          $scope.feedbackList.push(
            $scope.feedbackRequest[$scope.feedbackMax + i]
          );
          i++;
        }
        $scope.feedbackMax += i;
        if (i != 7 && $scope.feedbackRequest.length != 0) {
          $http({
            url: configuration.webApi.users.reviews({
              id: $scope.profileData.user.Id
            }),
            method: "GET",
            data: {
              dateLT:
                $scope.feedbackRequest[$scope.feedbackRequest.length - 1]
                  .CreatedDate
            }
          })
            .success(function (res, status, headers, config) {
              $scope.feedbackRequest.concat(res);
              while (
                i < 7 &&
                $scope.feedbackRequest.length > i + $scope.feedbackMax
              ) {
                $scope.feedbackList.push(
                  $scope.feedbackRequest[$scope.feedbackMax + i]
                );
                i++;
              }
              $scope.feedbackMax += i;
              //console.log($scope.projectHistoryList);
            })
            .error(function (error, status, headers, config) {
              $scope.alertErrorFromServer(error);
              //authFactory.logout();
            });
        }
      }
    };

    $scope.loadReview = function (userId) {
      $http({
        url: configuration.webApi.users.reviews({
          id: $scope.profileData.user.Id
        }),
        method: "GET",
        data: {}
      })
        .success(function (res, status, headers, config) {
          $scope.feedbackRequest = res;
          $scope.loadFeedbackList();
        })
        .error(function (error, status, headers, config) {
          $scope.alertErrorFromServer(error);
        });
    };

    $scope.loadProjectHistory = function (userId) {
      $http({
        url: configuration.webApi.users.projecthistory({
          id: $scope.profileData.user.Id
        }),
        method: "GET",
        data: {}
      })
        .success(function (res, status, headers, config) {
          $scope.projectHistoryRequest = res;
          $scope.projectHistoryRequestLoaded = true;
          $scope.loadProjectHistoryList();
          //console.log($scope.projectHistoryList);
        })
        .error(function (error, status, headers, config) {
          $scope.alertErrorFromServer(error);
          //authFactory.logout();
        });
    };

    $scope.loadLicenses = function (userId) {
      $http({
        url: configuration.webApi.users.licenses({
          id: $scope.profileData.user.Id
        }),
        method: "GET",
        data: {}
      })
        .success(function (res, status, headers, config) {
          loadLicenses(res);
          //console.log(res);
          //console.log($scope.professionalLicenses);
        })
        .error(function (error, status, headers, config) {
          $scope.alertErrorFromServer(error);
          //authFactory.logout();
        });
    };

    $scope.updateProfile = function () {
      if ($scope.newPassword) {
        updatePassword().then(function () {
          if ($scope.user.IsClient) $scope.updateProfileClient();
          else $scope.updateProfileProfessional();
        });
      } else {
        if ($scope.user.IsClient) $scope.updateProfileClient();
        else $scope.updateProfileProfessional();
      }
    };

    $scope.updateProfileClient = function () {
      //console.log($scope.website);
      $http({
        url: configuration.webApi.users.users,
        method: "PATCH",
        data: {
          Email: $scope.mail,
          Company: $scope.company,
          FirstName: $scope.firstName,
          LastName: $scope.lastName,
          Phone: $scope.phone,
          City: $scope.city,
          State: $scope.state ? $scope.state.Code : "",
          Zip: $scope.zip,
          WebSite: $scope.website
        }
      })
        .success(function (res, status, headers, config) {
          $scope.loadUser(res);

          var modalResult = $uibModal.open({
            templateUrl: "modal-thanks.html",
            size: "sm",
            scope: $scope,
            controller: [
              "$scope",
              "$uibModalInstance",
              "$q",
              function ($scope, $uibModalInstance, $q) {
                // We could do something in the modal here.
              }
            ]
          });

          modalResult.closed.then(function (data) { });
        })
        .error(function (error, status, headers, config) {
          $scope.alertErrorFromServer(error);
          //authFactory.logout();
        });
    };

    $scope.updateProfileProfessional = function () {
      var distance;
      if ($scope.travelDistance.value == null) distance = null;
      else distance = parseInt($scope.travelDistance.value * 1609.34);

      var reqData = {
        Email: $scope.mail,
        Company: $scope.company,
        FirstName: $scope.firstName,
        LastName: $scope.lastName,
        Phone: $scope.phone,
        City: $scope.city,
        State: $scope.state ? $scope.state.Code : "",
        Zip: $scope.zip,
        TravelDistanceMeters: distance,
        Licenses: getProfessionalLicenses()
      };

      $http({
        url: configuration.webApi.users.users,
        method: "PATCH",
        data: reqData
      })
        .success(function (res, status, headers, config) {
          // Copy modified data into user
          angular.extend($scope.user, res);

          var modalResult = $uibModal.open({
            templateUrl: "modal-thanks.html",
            size: "sm",
            scope: $scope,
            controller: [
              "$scope",
              "$uibModalInstance",
              "$q",
              function ($scope, $uibModalInstance, $q) {
                // We could do something in the modal here.
              }
            ]
          });

          modalResult.closed.then(function (data) { });
        })
        .error(function (error, status, headers, config) {
          $scope.alertErrorFromServer(error);
        });
    };

    $scope.updateBio = function () {
      Upload.upload({
        url: configuration.webApi.users.users,
        method: "PATCH",
        data: {
          Bio: $scope.bio,
          BioAttachment: $scope.file,
          WebSite: $scope.website
        }
      })
        .success(function (res, status, headers, config) {
          $scope.loadUser(res);
          $scope.user.Bio = $scope.bio;
          $scope.user.BioAttachment = $scope.file;
          $scope.user.WebSite = $scope.website;
          var modalResult = $uibModal.open({
            templateUrl: "modal-thanks.html",
            size: "sm",
            scope: $scope,
            controller: [
              "$scope",
              "$uibModalInstance",
              "$q",
              function ($scope, $uibModalInstance, $q) {
                // We could do something in the modal here.
              }
            ]
          });
          modalResult.closed.then(function (data) { });
        })
        .error(function (error, status, headers, config) {
          $scope.alertErrorFromServer(error);
          //authFactory.logout();
        });
    };

    $scope.uploadImage = function () {
      var deferred = $q.defer();
      Upload.upload({
        url: configuration.webApi.users.picture,
        method: "PATCH",
        data: {
          Picture: $scope.file
        }
      }).then(
        function (data) {
          deferred.resolve(data);
          $scope.user.Picture = data.data;
        },
        function (data) {
          $scope.alertErrorFromServer(data);
          deferred.reject(data);
        },

        //progress callback
        function (evt) {
          deferred.notify({
            prog: evt.loaded / evt.total,
            evt: evt
          });
        }
      );
      return deferred.promise;
    };

    $scope.uploadImg = function (f) {
      if (!f) {
        return;
      }

      $scope.uploadImage().then(
        function (res) { },
        function (error) {
          console.log(error);
        }
      );
    };

    $scope.changeTab = function (b) {
      $scope.showMainTab = b;
    };

    $scope.addLicense = function () {
      $scope.professionalLicenses.push({
        type: undefined,
        state: undefined,
        expires: undefined,
        popup: {
          opened: false
        }
      });
    };

    $scope.removeLicense = function (index) {
      $scope.professionalLicenses.splice(index, 1);
    };

    $scope.lastLicense = function (index) {
      return $scope.professionalLicenses.length - 1 == index;
    };

    var getProfessionalLicenses = function () {
      var lista = [];
      $scope.engineerLicenses = "";
      for (i in $scope.professionalLicenses) {
        lista.push({
          LicenseId: $scope.professionalLicenses[i].type.Id,
          LicenseIdLabel: $scope.professionalLicenses[i].type.Label,
          LicenseState: $scope.professionalLicenses[i].state.Code,
          LicenseStateLabel: $scope.professionalLicenses[i].state.Label,
          Expires: moment($scope.professionalLicenses[i].expires).toDate()
        });

        $scope.engineerLicenses += "Licensed " + $scope.professionalLicenses[i].type.Label + " in " + $scope.professionalLicenses[i].state.Label;
        if (i != $scope.professionalLicenses.length - 1) {
          $scope.engineerLicenses += " | ";
        }
      }

      if ($scope.professionalLicenses.length > 0) {
        $scope.engineerFirstLicense = $scope.professionalLicenses[0].type.Label;
      }
      return lista;
    };

    var groupLicenses = function () {
      var l = getProfessionalLicenses();

      $scope.groupedLicenses = _.groupBy(l, function (i) {
        return i.LicenseId;
      });
    };

    var loadLicenses = function (data) {
      for (i in data) {
        var w = data[i];
        $scope.professionalLicenses.push({
          type: $scope.getLicenseFromId(w.LicenseId),
          state: $scope.getStateFromCode(w.State),
          expires: moment(w.Expires).toDate(),
          popup: {
            opened: false
          }
        });
      }
      if ($scope.professionalLicenses.length == 0) {
        $scope.professionalLicenses = [
          {
            type: undefined,
            state: undefined,
            expires: undefined,
            popup: {
              opened: false
            }
          }
        ];
      } else {
        groupLicenses();
      }
    };

    $scope.editUrl = function () {
      if (
        $scope.profileData.user.WebSite &&
        $scope.profileData.user.WebSite.substring(0, 7) == "http://"
      )
        $scope.profileData.user.WebSiteRoot = $scope.profileData.user.WebSite.substring(
          7
        );
      else if (
        $scope.profileData.user.WebSite &&
        $scope.profileData.user.WebSite.substring(0, 8) == "https://"
      )
        $scope.profileData.user.WebSiteRoot = $scope.profileData.user.WebSite.substring(
          8
        );
      else
        $scope.profileData.user.WebSiteRoot = $scope.profileData.user.WebSite;
    };

    var updatePassword = function () {
      var df = $q.defer();
      if ($scope.newPassword != $scope.reNewPassword) {
        $scope.alertError("Error", "The passwords do not match");
        df.reject();
      } else {
        $http({
          url: configuration.webApi.auth.change_password,
          method: "POST",
          data: {
            Password: $scope.newPassword
          }
        })
          .success(function (res, status, headers, config) {
            var new_token = res;

            /*var expiresAt = res.exp_iat * 1000;
        var now = new Date().getTime();*/

            /*StorageService.save(configuration.storage.token, new_token);
        StorageService.save(configuration.storage.token_valid_from, now);
        StorageService.save(configuration.storage.token_will_expire, expiresAt);

        initRefreshToken(now, expiresAt);*/
            AuthService.save(new_token);
            //console.log(res.User);
            // $scope.loadUser(res.User);
            df.resolve();
          })
          .error(function (error, status, headers, config) {
            $scope.alertErrorFromServer(error);
            df.reject();
          });
      }
      return df.promise;
    };

    $scope.getLatLng = function () {
      $http
        .get(
          "https://maps.googleapis.com/maps/api/geocode/json?address=" +
          $scope.zip +
          "&sensor=true" +
          "&key=" +
          configuration.googleApiKey
        )
        .success(function (res) {
          $scope.latLng = res.results[0].geometry.location;
          if ($scope.travelDistance.value) {
            $scope.distance = parseInt($scope.travelDistance.value * 1609.34);
          } else {
            $scope.distance = 0;
          }
        });
    };

    $scope.getLatLngProfile = function () {
      $http
        .get(
          "https://maps.googleapis.com/maps/api/geocode/json?address=" +
          $scope.profileData.user.Zip +
          "&sensor=true" +
          "&key=" +
          configuration.googleApiKey
        )
        .success(function (res) {
          $scope.latLng = res.results[0].geometry.location;
        });
      $scope.distance = $scope.profileData.user.TravelDistanceMeters;
    };

    $scope.invalidDate = function (date) {
      var date1 = moment(date)
        .hour(0)
        .seconds(0)
        .minutes(0);
      var date2 = $scope.minDate
        .hour(0)
        .seconds(0)
        .minutes(0);
      return moment.duration(date1.diff(date2)).asDays() < -1;
    };

    $scope.invalid = function () {
      for (var i in $scope.professionalLicenses) {
        if (
          !$scope.professionalLicenses[i].state ||
          !$scope.professionalLicenses[i].type ||
          $scope.invalidDate($scope.professionalLicenses[i].expires)
        ) {
          return true;
        }
      }
      return false;
    };

    $scope.requestProposal = function () {
      $http({
        url: configuration.webApi.projects.requestProposal({
          id: $scope.requestProposalData.project.Id,
          engId: $scope.profileData.user.Id
        }),
        method: "POST",
        data: {}
      })
        .success(function (res, status, headers, config) {
          $uibModal.open({
            templateUrl: "requestProposalSuccessModal.html",
            size: "md",
            scope: $scope
          });
        })
        .error(function (error, status, headers, config) {
          $scope.alertErrorFromServer(error);
        });
    };

    $scope.help = function () {
      $uibModal.open({
        templateUrl: "requestProposalHelp.html",
        size: "md",
        scope: $scope
      });
    };

    $scope.removeFile = function () {
      $scope.file = undefined;
    };

    init();
  });
